import type { CSSProperties } from 'react'
import styles from './Icon.module.css'
import { ICON_CODEPOINTS, type IconName } from './iconNames'

export type { IconName }

interface IconProps {
  name: IconName
  size?: number
  /** Any CSS colour; defaults to the parent's text colour. */
  color?: string
  className?: string
  style?: CSSProperties
}

/** Decorative icon: FILL 0 / wght 400 (see Icon.module.css). Give the parent control an aria-label. */
export function Icon({ name, size = 24, color, className, style }: IconProps) {
  return (
    <span
      aria-hidden="true"
      className={`${styles.icon} ${className ?? ''}`}
      style={{ fontSize: size, width: size, height: size, color, ...style }}
    >
      {String.fromCodePoint(ICON_CODEPOINTS[name])}
    </span>
  )
}
